import { AxiosInstanceLongTimeOut } from "@service/axios-instance";

export const getImuConfig = async (tid: string, db: string) => {
    const response = await AxiosInstanceLongTimeOut.get(`/imu-diagnostics/config`, {
        params: { tid, db },
        withCredentials: true
    });
    return response.data;
};

export const updateImuConfig = async (tid: string, db: string, params: any) => {
    const response = await AxiosInstanceLongTimeOut.post(`/imu-diagnostics/config/update`, 
        { tid, params }, 
        { params: { db }, withCredentials: true }
    );
    return response.data;
};

export const triggerImuRecording = async (tid: string, db: string, duration: number) => {
    const response = await AxiosInstanceLongTimeOut.post(`/imu-diagnostics/trigger`, 
        { tid, duration }, 
        { params: { db }, withCredentials: true }
    );
    return response.data;
};

export const listImuRecords = async (tid: string, db: string) => {
    const response = await AxiosInstanceLongTimeOut.get(`/imu-diagnostics/records/${tid}`, {
        params: { db },
        withCredentials: true
    });
    return response.data;
};

export const downloadImuRecordUrl = (filename: string, db: string) => {
    return `/imu-diagnostics/download/${filename}?db=${db}`;
};
export const getImuSummary = async (db: string) => {
    const response = await AxiosInstanceLongTimeOut.get(`/imu-diagnostics/summary`, {
        params: { db },
        withCredentials: true
    });
    return response.data;
};

export const deleteImuRecord = async (filename: string, db: string) => {
    const response = await AxiosInstanceLongTimeOut.delete(`/imu-diagnostics/delete/${filename}`, {
        params: { db },
        withCredentials: true
    });
    return response.data;
};
